import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApplicationRef } from '@angular/core';
import { finalize } from 'rxjs';

/**
 * HTTP Interceptor that triggers change detection after API responses.
 *
 * Fixes issues where:
 * 1. API returns data but the page keeps showing skeleton/loading
 * 2. User must click on the screen to see the response
 *
 * These occur when async callbacks run without triggering Angular's change detection
 * (e.g. outside NgZone or before CD runs). This interceptor forces a tick after each
 * HTTP response so the UI updates immediately.
 */
let tickScheduled = false;

export const changeDetectionInterceptor: HttpInterceptorFn = (req, next) => {
  const appRef = inject(ApplicationRef);

  return next(req).pipe(
    finalize(() => {
      if (appRef.destroyed || tickScheduled) {
        return;
      }
      tickScheduled = true;
      setTimeout(() => {
        tickScheduled = false;
        if (!appRef.destroyed) {
          appRef.tick();
        }
      }, 0);
    }),
  );
};
